/**
 * Profile pictures: Jens's series of ants (2026-10-11), in public/avatars/. Everyone starts as
 * ant_basic. The Queen ant speaks for the family wherever the app's mascot appears (messages,
 * empty states, goals) until the grown-up who started the family picks a picture of their own.
 */
export const DEFAULT_AVATAR = '/avatars/ant_basic.png';
export const QUEEN_AVATAR = '/avatars/ant_queen.png';

export const AVATAR_PRESETS = [
  'basic', 'queen', 'king', 'knight', 'astronaut', 'admiral', 'pirate', 'ninja', 'punk', 'bandana',
].map((n) => `/avatars/ant_${n}.png`);

/** The old placeholder pictures (avatar_01–08.svg) — treated as "nothing chosen yet". */
const isLegacyPlaceholder = (url: string) => /^\/avatars\/(avatar_\d+\.svg|default_avatar\.png)$/.test(url);

/** The picture to show for a member: theirs, or the basic ant. */
export function avatarOrDefault(url?: string | null): string {
  if (!url || isLegacyPlaceholder(url)) return DEFAULT_AVATAR;
  return url;
}

/** Has this person picked (or uploaded) a picture, rather than keeping the default? */
export function hasChosenAvatar(url?: string | null): boolean {
  return !!url && !isLegacyPlaceholder(url) && url !== DEFAULT_AVATAR;
}

/** Is this a photo the person uploaded (which they can remove), not one of the app's ant pictures? */
export function isUploadedAvatar(url?: string | null): boolean {
  return !!url && /^https?:\/\//i.test(url) && !AVATAR_PRESETS.includes(url);
}

/** The mascot picture: the family founder's chosen avatar, otherwise the Queen ant. */
export function mascotSrc(
  family: { admin_id?: string | null; members?: Array<{ id: string; avatar_url?: string | null }> } | null | undefined,
): string {
  const founder = family?.members?.find((m) => m.id === family?.admin_id);
  return hasChosenAvatar(founder?.avatar_url) ? (founder!.avatar_url as string) : QUEEN_AVATAR;
}
